import routes from './../companies/default/router/routes'
import apiService from '@/services/api.service'
import env from '@/../.env'

function getKeyname() {

    // Check base domaine url
    if (inDomainName()) {
        return confFile().url_keyname
    }

    // Init variables
    let currentUrl = window.location.href

    // Parse URL
        // Remove "/" on end url 
        if (currentUrl.slice(-1) == '/') {
            currentUrl = currentUrl.slice(0, -1)
        }
        // Remove queries in url
        currentUrl = currentUrl.split('?')[0]
        // Split url at each "/"
        let params = currentUrl.split("/");

        // Clean url params with default route in .env file
        let defaultRouteParams = (env.DEFAULT_ROUTE.charAt(0) == '/' ? env.DEFAULT_ROUTE.substring(1) : env.DEFAULT_ROUTE).split('/')
        let paramsWithoutDomainName = [...params].splice(3, params.length - 3)
        defaultRouteParams.forEach((defaultParam) => {
            if (paramsWithoutDomainName[0] == defaultParam) {
                paramsWithoutDomainName.splice(0, 1)
            }
        })

    // If there is keyname after "/" (ex: /casino)
    if (paramsWithoutDomainName.length > 0) {
        let companyName = paramsWithoutDomainName[0]
        let currentPath = params.splice(3, params.length).join('/')

        // Check if route exists to pass "/form" for example
        let routeDefaultExist = routes.list.find(route => route.path == ('/' + currentPath))
        if (!routeDefaultExist) {
            return companyName
        }
    }

    // If no value, return default keyname
    return "default"
}

async function getLang() {
    let lang = 'FR'

    if (localStorage.getItem('langage')) {
        if (localStorage.getItem('langage') == 'fr-FR') {
            lang = 'FR'
        } else {
            lang = localStorage.getItem('langage')
        }
    }

    let langConf = await apiService.postProd('getlang', {langue: lang})
    langConf = langConf.data.posts.post[0]

    if (langConf && langConf.contenu) {
        langConf.contenu = JSON.parse(langConf.contenu)
    } else {
        langConf = await apiService.postProd('getlang', {langue: 'FR'})
    }

    // Overwrite with alias text
    if (confFile() && confFile().textes) {
        const overwriteLang = JSON.parse(confFile().textes)
        if (overwriteLang[langConf.lang]) {
            overwriteLang[langConf.lang].forEach((text) => {
                langConf.contenu[text.key] = text.value
            })
        }
    }
    return langConf
}

function confFile() {
    let spaceConf = localStorage.getItem('space-conf')

    if (spaceConf) {
        spaceConf = JSON.parse(spaceConf)
        spaceConf.mobile = spaceConf.mobile == '1' ? true : false
        spaceConf.translates = spaceConf.translates == '1' ? true : false
        spaceConf.demo = spaceConf.demo == '1' ? true : false
        spaceConf.style = JSON.parse(spaceConf.style)
        if (spaceConf.overwrite_folder == 'null' || !spaceConf.overwrite_folder) {
            spaceConf.overwrite_folder = 'default'
        }
        if (spaceConf.images) {
            spaceConf.images = JSON.parse(spaceConf.images)
        } else {
            spaceConf.images = {
                default: null,
                exceptions: []
            }
        }
        spaceConf.process = {
            name: spaceConf.process_name,
            directory: spaceConf.process_directory
        }
    }
    return spaceConf
}

function inDomainName() {
    let domainName = window.location.hostname
    const configFile = confFile()
    if (configFile && configFile.domain_name == domainName) {
        return true
    }
    return false
}

function demoSpace() {
    const configFile = confFile()
    if (configFile && configFile.demo) {
        return true
    }
    return false
}

function processConf()
{
    const configFile = require ('@/processes/conf/' + confFile().process.directory).default
    return configFile
}

const keyname = getKeyname()


var CompanyTool = {
    keyname,
    confFile,
    inDomainName,
    demoSpace,
    processConf,
    getLang
}

export default CompanyTool



// WEBPACK FOOTER //
// ./src/tools/CompanyTool.js